import api from './api';
import { formatCartPriceData } from './helper';

const PRICING_URL = '/api/price';

export const simulateCartPrice = async (clientId, productIds) => {
  const response = await api.post(`${PRICING_URL}/simulation/`, {
    datetime: new Date(),
    client_id: clientId,
    product_ids: productIds,
  });

  return formatCartPriceData(response.data);
};

export default simulateCartPrice;
